import CareersTemplate from '~templates/careers'
export default CareersTemplate